export interface ToCsvInput {
  headers: string[];
  rows: Array<Record<string, string>>;
}

export interface DownloadCsvInput {
  filename: string;
  csv: string;
}

const NEEDS_QUOTING = /[",\r\n]/;

/**
 * RFC 4180: wrap a field in quotes when it holds a comma, quote or newline,
 * and escape an embedded quote by doubling it.
 */
const escapeField = (value: string): string =>
  NEEDS_QUOTING.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

export const toCsv = ({ headers, rows }: ToCsvInput): string => {
  const lines = [
    headers.map(escapeField).join(','),
    ...rows.map((row) =>
      headers.map((header) => escapeField(row[header] ?? '')).join(',')
    ),
  ];

  return lines.join('\r\n');
};

export const downloadCsv = ({ filename, csv }: DownloadCsvInput): void => {
  // The BOM makes Excel read the file as UTF-8 rather than the system codepage.
  const blob = new Blob([`\uFEFF${csv}`], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
